export enum SectionCompanyLogo {
  AIRBUS = 'airbus',
  AMAZON = 'amazon',
  AUTOMATION_ANYWHERE = 'automation-anywhere',
  DELOITTE = 'deloitte',
  FACEBOOK = 'facebook',
  NASA = 'nasa',
  UNIVERSITAT_BONN = 'universitat-bonn',
  YARA = 'yara',
  SYDNEYMETRO = 'sydneymetro',
  PYBAR_MINING = 'pybar-mining-services',
  HAPAG_LLOYD = 'hapag-lloyd',
  BARRICK = 'barrick',
}

export enum SectionCompanyLogoColor {
  LIGHT = 'light',
  DARK = 'dark',
}
